import { render } from "./command.vue?vue&type=template&id=d27692e6&scoped=true"
import script from "./command.vue?vue&type=script&lang=js"
export * from "./command.vue?vue&type=script&lang=js"

import "./command.vue?vue&type=style&index=0&id=d27692e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d27692e6"

export default script